const BOUNDS = {
  LOWER: 1,
  UPPER: 2000000000,
  NAME_LENGTH: 23,
};

export { BOUNDS };
